import { MvmShedMovementSearch } from '../interfaces/Mvm';
import { BillingRecordReportParameters, BusinessSecurityReportParameters, MvmListReportParameters, MvmNoJustificationWindowReportParams, PendingXMLRequestParams, ScheduledBalanceParams } from '../interfaces/Report';
import { ShippingRequestReportParams } from '../interfaces/ShippingRequest';
import { getUrlReportApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlReportApi(window));

export default class ReportApi {
	static async printMvm(mvmId: string) {
		ReportApi.exportReport('/api/report/mvm-print', true, { mvmId: mvmId });
	}

	static async printShippingRequestReport(
		params: ShippingRequestReportParams
	) {
		ReportApi.exportReport(
			'/api/report/shipping-request',
			true,
			params
		);
	}

	static async printMvmNoJustificationWindow(
		params: MvmNoJustificationWindowReportParams
	) {
		ReportApi.exportReport(
			'/api/report/mvm-no-window-justification',
			true,
			params
		);
	}

	static async printMvmShedMovementReport(params: MvmShedMovementSearch) {
		ReportApi.exportReport(
			'/api/report/mvm-shed-movement',
			true,
			params
		);
	}

	static async printPendingXMLRequest(params: PendingXMLRequestParams) {
		ReportApi.exportReport(
			'/api/report/pending-xml-request',
			true,
			params
		);
	}

    static async printScheduledBalance(params: ScheduledBalanceParams) {
        ReportApi.exportReport('/api/report/scheduled-balance', true, params);
    }

    static async searchMvmShedMovement(params: MvmShedMovementSearch) {
        var response = await ApiHandler(baseURL).get('/report/mvm-shed-movement-search', { params });
        return response.data;
    }

	static async printBillingRecord(params: BillingRecordReportParameters) {
		ReportApi.exportReport('/api/report/mvm-billing-record', true, params);
	}

	static async printBusinessSecurity(
		params: BusinessSecurityReportParameters
	) {
		ReportApi.exportReport('/api/report/business-security', true, params);
	}

	static async printMvmList(params: MvmListReportParameters) {
		ReportApi.exportReport('/api/report/mvm-list', true, params);
	}

	//Criar um <form> na pagina atual, para submeter para a API de reports e exibir o mesmo numa pagina nova
	static exportReport(url: String, newTab: boolean, params: any) {
		var reportForm = document.createElement('form');
		reportForm.action = baseURL + url;
		reportForm.target = newTab ? '_blank' : '_self';
		reportForm.method = 'POST';
		reportForm.enctype = 'application/x-www-form-urlencoded';

		//Report parameters: Para cada propriedade de params, incluir um hidden field no form. Se for array, incluir repetidamente
		for (var parameterName in params) {
			if (Array.isArray(params[parameterName]))
				for (var i in params[parameterName]) {
					var input = document.createElement('input');
					input.type = 'hidden';
					input.name = parameterName;
					input.value = String(params[parameterName][i]).trim();
					reportForm.appendChild(input);
				}
			else if (params[parameterName] !== undefined && params[parameterName] !== null) {
				var appendInput = document.createElement('input');
				appendInput.type = 'hidden';
				appendInput.name = parameterName;
				appendInput.value = String(params[parameterName]).trim();
				reportForm.appendChild(appendInput);
			}
		}

		document.body.appendChild(reportForm);
		reportForm.submit();
	}
}
